import React, { useState, useEffect } from "react";
import Card from "./components/card";
import { Col, Row, Space, Input } from "antd";
import phone from "./images/phone.svg";
import mail from "./images/mail.svg";
import location from "./images/location.svg";
import time from "./images/time.svg";
import faq_1 from "./images/icons/faq_1.svg";
import faq_2 from "./images/icons/faq_2.svg";
import faq_3 from "./images/icons/faq_3.svg";
import faq_4 from "./images/icons/faq_4.svg";
import faq_5 from "./images/icons/faq_5.svg";
import faq_6 from "./images/icons/faq_6.svg";
import faq_7 from "./images/icons/faq_7.svg";
import faq_8 from "./images/icons/faq_8.svg";
import search from "./images/search.svg";

const categories = [
  {
    icon: faq_1,
    text: "Kaina",
    link: "../duk/kaina"
  },
  {
    icon: faq_2,
    text: "Siuntos užsakymo pateikimas internetu",
    link: "../duk/siuntos-uzsakymo-pateikimas-internetu"
  },
  {
    icon: faq_3,
    text: "Siuntos paėmimas",
    link: "../duk/siuntos-paemimas"
  },
  {
    icon: faq_4,
    text: "Siuntos pristatymas",
    link: "../duk/siuntos-pristatymas"
  },
  {
    icon: faq_5,
    text: "Siuntos",
    link: "../duk/siuntos"
  },
  {
    icon: faq_6,
    text: "Viskas apie OMNIVA paštomatus",
    link: "../duk/viskas-apie-omniva-pastomatus"
  },
  {
    icon: faq_7,
    text: "Muitinės kontroliuojamos siuntos",
    link: "../duk/muitines-kontroliuojamos-siuntos"
  },
  {
    icon: faq_8,
    text: "Pažeistos, dingusios, apgadintos siuntos ir draudimas",
    link: "../duk/pazeistos-dingusios-apgadintos-siuntos-ir-draudimas"
  }
]

const Faq = () => {

  const [searchValue, serSearchValue] = useState("");

  return (
    <div className="margin-100-x" style={{
      paddingTop: 40,
      paddingBottom: 30
    }}>
      <h2 className="bolded text-center">Dažniausiai užduodami klausimai</h2>
      <Row gutter={[32, 32]} className="mt-4">
        {categories.map((category, index) => (
          <Col span={24} md={{ span: 8 }} xl={{ span: 6 }} key={index}>
            <Card info={category} />
          </Col>
        ))}
      </Row>
      <h3 className="mt-5 text-center">
        Atsakymo galite ieškoti čia
      </h3>
      <div style={{
        position: "relative",
        maxWidth: "540px",
        marginInline: "auto"
      }}>
        <Input
          placeholder="Paieška"
          size="large"
          className="tracking-input"
          onPressEnter={(event) => {
            window.location.href = `/duk?q%5Bquestion_or_answer_cont%5D=${event.target.value}`
          }}
          onChange={(event) => {
            serSearchValue(event.target.value)
          }}
        />

        <div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            right: 10,
            cursor: "pointer",
          }}
          onClick={() => {
            window.location.href = `/duk?q%5Bquestion_or_answer_cont%5D=${searchValue}`
          }}
        >
          <img src={search} alt="search" />
        </div>
      </div>
    </div>
  );
};

export default Faq;
